const escapeKeyCode = 27;

const keyboardEvents = {
    /**
     * Функция проверяет нажатие клавиши Esc
     *
     * @param {Number} keyCode Код клавиши для проверки
     */
    isExit: (keyCode) => keyCode === escapeKeyCode
};

export default keyboardEvents;
